var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.6C19 4.6 17.4 3 13.4 3H8.6C4.6 3 3 4.6 3 8.6V13.4C3 17.4 4.6 19 8.6 19",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 7C14.8 6.3 13.88 6 12.5 6H9.5C7 6 6 7 6 9.5V12.5C6 13.88 6.3 14.8 6.99 15.35",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7101 17.5899C16.5882 17.5899 17.3001 16.878 17.3001 15.9999C17.3001 15.1218 16.5882 14.4099 15.7101 14.4099C14.832 14.4099 14.1201 15.1218 14.1201 15.9999C14.1201 16.878 14.832 17.5899 15.7101 17.5899Z",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4102 16.46V15.53C10.4102 14.98 10.8602 14.53 11.4102 14.53C12.3702 14.53 12.7602 13.85 12.2802 13.02C12.0002 12.54 12.1702 11.92 12.6502 11.65L13.5602 11.12C13.9802 10.87 14.5202 11.02 14.7702 11.44L14.8302 11.54C15.3102 12.37 16.0902 12.37 16.5702 11.54L16.6302 11.44C16.8802 11.02 17.4202 10.88 17.8402 11.12L18.7502 11.65C19.2302 11.93 19.4002 12.54 19.1202 13.02C18.6402 13.85 19.0302 14.53 19.9902 14.53C20.5402 14.53 20.9902 14.98 20.9902 15.53V16.46C20.9902 17.01 20.5402 17.46 19.9902 17.46C19.0302 17.46 18.6402 18.14 19.1202 18.97C19.4002 19.45 19.2302 20.07 18.7502 20.34L17.8402 20.87C17.4202 21.12 16.8802 20.97 16.6302 20.55L16.5702 20.45C16.0902 19.62 15.3102 19.62 14.8302 20.45L14.7702 20.55C14.5202 20.97 13.9802 21.11 13.5602 20.87L12.6502 20.34C12.1702 20.06 12.0002 19.45 12.2802 18.97C12.7602 18.14 12.3702 17.46 11.4102 17.46C10.8602 17.47 10.4102 17.02 10.4102 16.46Z",
    stroke: "#E5EAF9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/CMS.22c483cf9ee8aedcea6de15ae78ac968.svg";
export { ForwardRef as ReactComponent };